<template>
    <rkm-row>
        <rkm-col cols="6">
            <rkm-form-input
                label="Nome"
                v-model="model.cidadao.nome"
                uppercase
                disabled
            />
        </rkm-col>

        <rkm-col cols="6">
            <rkm-form-input
                label="Nome Social"
                v-model="model.cidadao.nomeSocial"
                uppercase
                disabled
            />
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-input
                label="N° CNS"
                v-model="model.cidadao.cns"
                disabled
            />
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-date-picker
                label="Data de nascimento"
                v-model="model.cidadao.dataNascimento"
                disabled
            />
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-input
                label="Sexo"
                v-model="model.cidadao.sexo"
                disabled
            />
        </rkm-col>
    </rkm-row>
</template>

<script>
export default {
    props: {
        model: { type: Object, required: false, },
    },
}
</script>
